<!--  -->
<template>
  <div class="EchartPractice">
    <div
      :class="className"
      :id="id"
      :style="{ width: '100%', height: '250px' }"
    ></div>
  </div>
</template>

<script>
  import * as echarts from 'echarts';

  export default {
    name: 'echarts-pie',
    props: {
      className: {
        type: String,
        default: 'chartPiesolid'
      },
      id: {
        type: String,
        default: 'chartPiesolid'
      },
      titletop: {
        type: String
      },
      itemsData: {
        type: Array
      }
    },
    data() {
      return {
        chart: null,
        dataList: []
      };
    },
    mounted() {
      this.DrawBarChart();
    },
    watch: {
      itemsData: {
        handler(newName, oldName) {
          if (oldName) {
            this.DrawBarChart();
          }
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      DrawBarChart() {
        this.chart = echarts.init(document.getElementById(this.id));
        this.chart.showLoading({
          text: 'loading',
          color: '#0084cd',
          textColor: '#0084cd',
          maskColor: 'rgba(255, 255, 255, 0.2)',
          zlevel: 0
        });
        let colors = ['#179F5D', '#4A8AF3', '#DA4C3F'];
        let app = {};
        this.dataList = this.itemsData;
        this.dataList[1].selected = true;

        let option;

        option = {
          title: {
            text: this.titletop,
            left: 'left',
            textStyle: {
              color: '#666',
              fontWeight: '100',
              fontSize: 13
            }
          },
          icon: 'circle',

          legend: {
            data: ['男', '女'],
            bottom: '15%',
            left: 'center',
            type: 'scroll'
          },

          series: [
            {
              type: 'pie',
              selectedMode: 'single',
              height: '80%',
              radius: [0, '55%'],
              minAngle: 10,
              label: {
                position: 'inner',
                fontSize: 14
              },

              itemStyle: {
                normal: {
                  label: {
                    position: 'inner',
                    show: true,
                    formatter: '{b}-{c}'
                  }
                }
              },
              labelLine: {
                show: false
              },
              data: this.dataList
            },
            // {
            //   type: 'pie',
            //   radius: ['45%', '60%'],
            //   labelLine: {
            //     length: 30
            //   }
            // }
          ]
        };
        setTimeout(() => {
          // setOption前隐藏loading事件
          this.chart.hideLoading();
          this.chart.setOption(option, true);
        }, 1000);
        // this.chart.setOption(option)
      }
    }
  };
</script>
<style lang="less" scoped>
  .EchartPractice {
    padding-top: 10px;
  }
  // .chartPiesolid {
  //   margin-left: 5%;
  // }
</style>
